<template lang="pug">
section(:id="id" :style="{'font-size': fontSize+'%'}")
  .section-header
    h5(:style="{'font-size': fontSize+'%'}" @click="openCitationsModal")
      | {{ label.toUpperCase() }}
    button.btnRelatedDocs(@click="openCitationsModal" v-if="hasCitedLegislations")
      i.fas.fa-book-open
      | {{ t('components.documents.section.related_docs') }}

  documents-paragraph-vue(
    v-if="!annotationsEnabled"
    v-for="(paragraph, index) in normalizedValue"
    :key="index"
    :text="paragraph"
    :show_all="show_all"
    :highlight_add_buttons="highlight_add_buttons"
    :highlight_background="highlight_background"
    :links-data="linksData"
  )

  annotatable-paragraph-vue(
    v-if="annotationsEnabled"
    v-for="(paragraph, index) in normalizedValue"
    :key="`para-${id}-${index}`"
    :text="paragraph"
    :show_all="show_all"
    :highlight_add_buttons="highlight_add_buttons"
    :highlight_background="highlight_background"
    :links-data="linksData"
    :section-id="id"
    :paragraph-index="index"
    :document-id="documentId"
    @show-annotation-menu="handleShowAnnotationMenu"
    @error="onAnnotationError"
    @show-delete-confirmation="$emit('show-delete-confirmation', $event)"
  )

  button.btnUP(@click="goUp" v-if="goUpButtonVisible")
    i.fas.fa-arrow-up
    | {{ t('components.documents.section.go_up') }}
</template>

<script>
import mixins from 'common/mixins'
import annotationHandlingMixin from 'common/mixins/annotation_handling'
import { mapState } from 'vuex'

export default {
  mixins: [mixins.translate, annotationHandlingMixin],
  props: {
    id: { type: String, default: '' },
    label: { type: String, default: '' },
    value: { type: [Array, String], default: () => [] },
    show_all: { type: Boolean, default: false },
    highlight_add_buttons: { type: Boolean, default: false },
    highlight_background: { type: Boolean, default: false },
    goUpButtonVisible: { type: Boolean, default: false },
    linksData: { type: Object, default: () => { return {} } },
    articleCitationsBus: { type: Object, default: null },
    documentId: { type: [String, Number], default: null },
    citedLegislationsArticles: { type: Object, default: () => { return {} } },
    annotationsEnabled: { type: Boolean, default: false }
  },

  components: {
    'documents-paragraph-vue': () => import(/* webpackChunkName: "[request]" */ "components/documents/Paragraph"),
    'annotatable-paragraph-vue': () => import(/* webpackChunkName: "[request]" */ "components/documents/AnnotatableParagraph")
  },

  computed: {
    normalizedValue() {
      if (Array.isArray(this.value)) return this.value
      if (typeof this.value === 'string') return this.value ? [this.value] : []
      return []
    },
    hasCitedLegislations() {
      if (!this.documentId || !this.id) return false
      const articleKey = `${this.documentId}#${this.id}`
      return Object.prototype.hasOwnProperty.call(this.citedLegislationsArticles, articleKey)
    },
    ...mapState(['fontSize'])
  },

  methods: {
    handleShowAnnotationMenu(eventData) {
      this.onShowAnnotationMenu(eventData)
    },

    goUp() {
      $(this.$el).scrollParent()[0].scrollTo({ top: 0, behavior: 'smooth' })
    },

    openCitationsModal() {
      if (!this.articleCitationsBus || !this.documentId) return
      this.articleCitationsBus.$emit('article_citations:show', {
        documentId: this.documentId,
        articleId: this.id
      })
    },

  }
}
</script>
